// Small relative-time helpers for staleness/offline display. `now` is
// injectable so the formatting is deterministically testable.

export function ageMs(iso: string, now: number = Date.now()): number {
  const t = Date.parse(iso);
  return Number.isNaN(t) ? Infinity : now - t;
}

export function relativeFromNow(iso: string, now: number = Date.now()): string {
  const ms = ageMs(iso, now);
  if (!Number.isFinite(ms)) return 'unknown';
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s < 45) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 1) return '1 min ago';
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.floor(h / 24);
  return `${d} day${d === 1 ? '' : 's'} ago`;
}
